import { Select } from "antd";
import { useState } from "react";

type SelectInputProps = {
	disabled?: boolean;
	initialValue?: string;
	onChange: (value: string) => void;
	options: string[];
	questionText?: string;
	optionLabelMap?: Record<string, string>;
	hasError?: boolean;
	addDefaultValue?: string;
	onAddDefault?: () => void;
};

const SelectInput = ({
	disabled = false,
	initialValue,
	onChange,
	options,
	optionLabelMap = {},
	hasError = false,
	addDefaultValue,
	onAddDefault
}: SelectInputProps) => {
	const hasDefault = addDefaultValue != null && onAddDefault != null;
	const [value, setValue] = useState<string | undefined>(hasDefault ? undefined : initialValue);

	const handleChange = (selectedValue: string) => {
		setValue(selectedValue);
		onChange(selectedValue);
	};

	const handleAddDefault = () => {
		if (addDefaultValue != null && onAddDefault != null) {
			setValue(addDefaultValue);
			onAddDefault();
		}
	};

	return (
		<div className="flex gap-2">
			<Select
				disabled={disabled}
				placeholder="Select option"
				value={value}
				onChange={handleChange}
				options={options.map((option) => ({
					label: optionLabelMap[option] || option,
					value: option
				}))}
				size="large"
				showSearch
				className={`flex-1 ${hasError ? "edc-select-error" : ""}`}
			/>
			{hasDefault && (
				<span
					role="button"
					tabIndex={0}
					onClick={(e) => {
						e.preventDefault();
						handleAddDefault();
					}}
					onKeyDown={(e) => {
						if (e.key === "Enter" || e.key === " ") {
							e.preventDefault();
							handleAddDefault();
						}
					}}
					className="flex items-center cursor-pointer text-indigo-600 hover:text-indigo-700 whitespace-nowrap">
					Add default
				</span>
			)}
		</div>
	);
};

export default SelectInput;

